module.exports = __webpack_public_path__ + "media/images/plus-27f69ba06f4b755600e461f114c4d630.png";